import { TService } from '@/models/services';
import { Stack, Switch, Text } from '@mantine/core';

export type IPriceCellConfig = {
  included: boolean;
  displayIcon: boolean;
};

export default function ParentServicePriceCellSettings({
  record,
  config,
  onChange,
}: {
  record: TService;
  config: IPriceCellConfig;
  onChange: (config: IPriceCellConfig) => void;
}) {
  return (
    <Stack>
      <Text size="xs" fw={500}>
        {record.name}
      </Text>
      {/* <Text size="xs" fw={500}>
        Service Price: {formatPrice(record.price, record.currency)}
      </Text> */}
      <Switch
        label="Included"
        size="xs"
        checked={config.included}
        onChange={(value) => {
          onChange({ ...config, included: value.currentTarget.checked });
        }}
      />
      <Switch
        label="Show icon instead of price"
        size="xs"
        checked={config.displayIcon}
        onChange={(value) => {
          onChange({ ...config, displayIcon: value.currentTarget.checked });
        }}
      />
    </Stack>
  );
}
